import instance from '../../../api/axios'

export const removeFolder = async (id: string): Promise<string> => {
  const response = await instance.delete(`/files/folders/${id}`)
  return response.data
}

export default removeFolder
